import React from 'react';
import { motion } from 'framer-motion';
import { Download, Zap, TrendingUp } from 'lucide-react';
const steps = [{
  icon: Download,
  title: 'Acceso Inmediato',
  description: 'Recibe el ebook digital, las plantillas y los ejercicios en tu correo en menos de 5 minutos.'
}, {
  icon: Zap,
  title: 'Aplica el Sistema',
  description: 'Usa el modelo IMÁN en tu próxima conversación, reunión o correo electrónico.'
}, {
  icon: TrendingUp,
  title: 'Resultados Reales',
  description: 'Observa cómo las decisiones dejan de flotar y empiezan a caer de tu lado.'
}];
export function HowItWorks() {
  return <section className="py-24 bg-[#1a3a52] text-white" data-id="element-209">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-210">
        <div className="text-center mb-20" data-id="element-211">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold mb-4" data-id="element-212">
            Cómo Funciona
          </motion.h2>
          <p className="text-gray-400" data-id="element-213">
            Sin complicaciones. Directo a la acción.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-214">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-[#C9A961]/20 z-0" data-id="element-215" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.3
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-216">
              <div className="w-24 h-24 bg-[#0f2942] border-2 border-[#C9A961] rounded-full flex items-center justify-center mb-8 shadow-[0_0_30px_rgba(201,169,97,0.2)]" data-id="element-217">
                <step.icon className="w-10 h-10 text-[#C9A961]" data-id="element-218" />
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-[#C9A961] rounded-full flex items-center justify-center text-[#1a3a52] font-bold" data-id="element-219">
                  {index + 1}
                </div>
              </div>

              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-220">
                {step.title}
              </h3>
              <p className="text-gray-300 max-w-xs" data-id="element-221">{step.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}